module.exports = __webpack_public_path__ + "static/salonslider-02-min-0da3b0aa706af556feb1e6b06cf6d295.jpg";